import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type {
  ModifyAppointmentRequestData,
  ModifyAppointmentResponseData,
} from '../utils/ModifyAppointmentRequestData';

export type { ModifyAppointmentResponseData } from '../utils/ModifyAppointmentRequestData';

export const APPOINTMENT_RESCHEDULE_MUTATION_KEY = ['appointment-reschedule'];

export const patchModifyAppointment = async (
  data: ModifyAppointmentRequestData,
): Promise<ModifyAppointmentResponseData> => {
  const { appointmentId, ...requestBody } = data;
  const url = getEndpoints().modifyAppointment.replace(
    '{appointmentId}',
    appointmentId,
  );

  return await apiWrapper<ModifyAppointmentResponseData>(url, {
    method: 'PATCH',
    data: requestBody,
  });
};
